export default __webpack_public_path__ + "static/media/right.b7ab6408.png";